// @ts-ignore
import { renderRoutes } from "utils/route";
import React, { Suspense } from "react";
import PageLoading from "./base/PageLoading";

const Root = ({ route }: any) => renderRoutes(route.routes);

export default Root;
